import { Form, Select } from 'antd'
import { ColumnProps } from 'antd/lib/table'

import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useColumnSearchProps } from '../../../../../../../components/Table/useColumSearchProps'
import { contextCompanyIdSelector } from '../../../../../../../redux/context/company/selectors'
import { GraphType } from '../../../types'
import { CompanyDashboardItemContext, CompanyDashboardContextType } from '../../DashboardItemProvider'
import DashboardItemFields from '../DasboardItemFieds'
import SelectionTableInput from '../SelectionTableInput'
import useSalesRecordItems from './useSalesRecordItems'

export type BaseSalesItem = {
  id: number | string
  name: string
}

const SalesChartFields = () => {
  const { t } = useTranslation()
  const { companyDashboardItemPreferenceSelection } = useContext(
    CompanyDashboardItemContext
  ) as CompanyDashboardContextType

  const record = companyDashboardItemPreferenceSelection?.params.record
  const companyId = useSelector(contextCompanyIdSelector)
  const { data: salesItems, isLoading: itemsLoading } = useSalesRecordItems(record, companyId)

  const columns: ColumnProps<BaseSalesItem>[] = [
    {
      title: t(`global:name`),
      key: 'name',
      dataIndex: 'name',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...useColumnSearchProps('name')
    }
  ]

  return (
    <>
      <DashboardItemFields />
      <Form.Item label={t('dashboardPage:chart-type')} name={['params', 'representation', 'options', 'type']}>
        <Select
          options={Object.values(GraphType).map(type => ({
            value: type,
            label: t(`dashboardPage:${type}`)
          }))}
        />
      </Form.Item>
      <Form.Item label={t(`global:${record?.slice(0, -1)}`)} name={['params', 'ids']}>
        <SelectionTableInput<BaseSalesItem> loading={itemsLoading} dataSource={salesItems} columns={columns} />
      </Form.Item>
    </>
  )
}

export default SalesChartFields
